<template>
  <v-row d-flex class="message message-bot messsge-loading" aria-hidden="true">
    <!-- contains message and response card -->
    <v-col ma-2 class="message-layout">

      <!-- contains message bubble and date -->
      <v-row d-flex class="message-bubble-date-container">
        <v-col class="message-bubble-column">

          <!-- contains message bubble and avatar -->
          <v-col d-flex class="message-bubble-avatar-container">
            <v-row class="message-bubble-row">
              <div
                class="message-bubble"
                aria-hidden="true"
              >
                <div class="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span v-if="$store.state.config.lex.allowStreamingResponses" class="streaming-text">
                  {{$store.state.streaming.wsMessagesString}}
                </span>
              </div>
            </v-row>
          </v-col>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/

export default {
  name: 'messageLoading',
  data() {
    return {
    };
  },
  computed: {
    isStartingTypingWsMessages(){
      return this.$store.getters.isStartingTypingWsMessages();
    }
  },
  methods: {
  },
  created() {
  },
  unmounted() {
  },
};
</script>

<style scoped>
.message, .message-bubble-column {
  flex: 0 0 auto;
}

.message, .message-bubble-row {
  max-width: 80vw;
}

.message-bubble {
  border-radius: 18px;
  display: inline-flex;
  font-size: calc(0.95em + 0.25vmin);
  padding: 10px 16px;
  width: fit-content;
  align-self: center;
  background-color: #f5f8fa !important;
  color: #2c3e50;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12);
  min-width: 60px;
  min-height: 24px;
}

.typing-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
}

.typing-indicator span {
  height: 8px;
  width: 8px;
  margin: 0 2px;
  background-color: #2c3e50;
  border-radius: 50%;
  opacity: 0.4;
  display: inline-block;
  animation: typing 1.4s infinite ease-in-out both;
}

.typing-indicator span:nth-child(1) {
  animation-delay: 0s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 0.4;
  }
}

.streaming-text {
  margin-left: 8px;
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.message-bot .message-bubble {
  background-color: #FFEBEE; /* red-50 from material palette */
}
</style>
